const env = {
  environment: import.meta.env.VITE_ENV,
  mode: import.meta.env.DEV ? 'development' : 'production',
  hcp: import.meta.env.VITE_HCP,
  hcpProxy: import.meta.env.VITE_HCP_PROXY,
  accounts: import.meta.env.VITE_ACCOUNTS,
  accountsProxy: import.meta.env.VITE_ACCOUNTS_PROXY,
  ip: import.meta.env.VITE_IP,
  ipProxy: import.meta.env.VITE_IP_PROXY,
  hcpUS: import.meta.env.VITE_US_HCP,
  hcpUSProxy: import.meta.env.VITE_US_HCP_PROXY,
  accountsUS: import.meta.env.VITE_US_ACCOUNTS,
  accountsUSProxy: import.meta.env.VITE_US_ACCOUNTS_PROXY,
  ipUS: import.meta.env.VITE_US_IP,
  ipUSProxy: import.meta.env.VITE_US_IP_PROXY,
  support: import.meta.env.VITE_ES_SUPPORT,
  signup: import.meta.env.VITE_ES_SIGNUP,
  datadog: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  datadogApplicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  gmap: import.meta.env.VITE_GMAP,
  cdn: import.meta.env.VITE_CDN,
  privacy: import.meta.env.VITE_PRIVACY,
  appVersion: import.meta.env.APP_VERSION,
};
export default env;
